<template>
    <div >
        <div class="whiteBox title">
            {{ $t('view.问题详情') }}
        </div>
        <div class="whiteBox MyQuestionDet">
            <el-form ref="details" label-width="120px" label-position="left" :model="details" :rules="dialogRules">
                <el-form-item prop="sectionId" :label="$t('view.招标项目名称')">
                    <el-select v-if="this.$store.getters.companyName" style="width: 460px;" :disabled="(details.status!=1&&details.id)?true:false" v-model="details.sectionId" filterable :placeholder="$t('view.请输入关键词')" >
                        <el-option style="width: 460px" :title="item.sectionName" v-for="item in projectList" :key="item.sectionId" :label="item.sectionName" :value="item.sectionId">
                        </el-option>
                    </el-select> 
                    <el-input v-else style="width: 460px;"  v-model="details.sectionName"></el-input>
                </el-form-item>
                <el-form-item prop="companyName" :label="$t('view.提问单位名称')">
                    <el-input  style="width: 460px;" :disabled="this.$store.getters.companyName?true:false" v-model="details.companyName"></el-input>
                </el-form-item>
                <el-form-item prop="problemDescription" :label="$t('view.问题描述')">
                    <el-input type="textarea" maxlength="500"  :rows="4" :disabled="(details.status!=1&&details.id)?true:false"  style="width: 100%" v-model="details.problemDescription"></el-input>
                </el-form-item>
                <el-form-item prop="username" :label="$t('view.附件')">
                    <div style="flex: 1" v-if="! details.files.length">
                        <el-upload
                            :limit="1"
                            :action="uploadFile"
                            :class="{'hide': details.files.length==1}"
                            :headers="headers" :on-success="(res,file)=>{successList(details.files,res,file)}"
                            :on-remove="(res,file)=>{handleRemove('files',res,file)}">
                            <img slot="trigger" style="vertical-align: middle;" :src="require('@/assets/BidDetails/icon-upload'+locale+'.png')">
                        </el-upload>
                    </div>
                    <div v-else style="display: flex;">
                        <File :close="!(details.status!=1&&details.id)" :listName="'files'" :file="details.files[0]"></File>      
                    </div>       
                </el-form-item>
                <el-form-item prop="createByName" :label="$t('view.提交人')">
                    <el-input style="width: 460px;"  :disabled="this.$store.getters.companyName?true:false" v-model="details.createByName"></el-input>
                </el-form-item>
                <el-form-item prop="createPhonenumber" :label="$t('view.联系电话')">
                    <el-input style="width: 460px;"  :disabled="this.$store.getters.companyName?true:false" v-model="details.createPhonenumber"></el-input>
                </el-form-item>
            </el-form>
            <div style="text-align: center ;" v-if="!details.id||details.status==1">
                <el-button style="width: 120px;" type="primary" @click="confirm(2)">{{ $t('view.提 交') }}</el-button>
                <el-button style="width: 120px;" type="primary" plain @click="confirm(1)">{{ $t('view.保 存') }}</el-button>
                <el-button style="width: 120px;" type="primary" plain @click="close">{{ $t('view.返回') }}</el-button>
            </div>
        </div>
        <div class="whiteBox" v-if="details.status==3">
            <div style="font-size: 18px;line-height: 28px;color: #303133;margin-bottom: 20px;">{{ $t('view.问题回复') }}</div>
            <el-form  label-width="120px" label-position="left" :model="details">
                <el-form-item :label="$t('view.问题回复情况')">
                    <el-input type="textarea" maxlength="500" :rows="4"  disabled style="width: 100%" v-model="details.problemReply"></el-input>
                </el-form-item>
                <el-form-item :label="$t('view.问题回复人')">
                    <el-input disabled style="width: 460px;" v-model="details.replyName"></el-input>
                </el-form-item>
                <el-form-item :label="$t('view.联系电话')">
                    <el-input disabled style="width: 460px;" v-model="details.replyPhonenumber"></el-input>
                </el-form-item>
                <el-form-item :label="$t('view.回复时间')">
                    <el-input disabled style="width: 460px;" v-model="details.replyTime"></el-input>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import {questionGetAuthSection} from '@/api/index'
import File from '@/components/file.vue'
  import { uploadFile } from '@/utils/request'
import {questionPut ,questionPost,questionGet} from '@/api/PersonalCenter'
  export default {
    components:{File},
    data(){

        return{
            sys_section_type:[],
            sys_section_stauts:[], //项目状态
            sys_section_stauts_tenders:[],//招标的项目状态
            sys_supplier_bid_status:[],//投标状态
            details:{
                files:[],
                companyName:'', 
                problemDescription:'', 
                createByName:'', 
                createPhonenumber:''
            },
             headers: {
                Authorization:getToken(),
            },
            uploadFile,
            locale: localStorage.getItem('locale')||'zh',
            projectList:[],
            dialogRules:{problemDescription: [{ required: true, trigger: 'changes', message: this.$t('view.请输入')}]},
        }
    },
    created(){
        this.details.companyName=this.$store.getters.companyName
        this.details.createByName=this.$store.getters.name
        this.details.createPhonenumber=this.$store.getters.phonenumber
        if(getToken())
        this.questionGetAuthSection()
        if(this.$route.query.id)
        this.questionGet(this.$route.query.id)
    },  
    methods:{
         // 附件查看与下载
        handleViewFile(filePath, fileName) {
            const ext = filePath.substr(filePath.lastIndexOf('.') + 1, filePath.length)
            if (ext == 'pdf' || 'PDF') {
                window.open(filePath, "_blank");
            } else {
                const eLink = document.createElement("a");
                eLink.download = fileName;
                eLink.style.display = "none";
                eLink.href = filePath;
                document.body.appendChild(eLink);
                eLink.click();
                eLink.remove()
            }
        },
         // 重新上传
        reuploadClick(list){
            this.$set(this.details,list,[])
            this.$forceUpdate()
        },
         // 上传文件
        successList(list,res,file){
            if(res.code!=200) return this.$message.error(this.$t('view.上传失败'))
            if(!list)
            list=[]
            list.push({
                fileName:res.newFileName,
                filePath:res.url,
                url: res.url,
                type:res.fileName.split(".").pop(),
                fileSize:res.fileSize,
            })
        },
        // 删除
        handleRemove(list, file, fileList) {
            this.$set(this.details,list,[])
            fileList.map(item=>{
                this.details[list].push({
                    fileName:item.response.originalFilename,
                    filePath:item.response.fileName,
                    url: item.response.url,
                })
            })
        },
         // 详情
        questionGet(id){
            questionGet(id).then(res=>{
                this.details=res.data
                this.dialogVisible=true
                this.details.companyName=this.$store.getters.companyName
                this.details.createByName=this.$store.getters.name
                this.details.createPhonenumber=this.$store.getters.phonenumber
            })
        },
        // 确认
        confirm(status){
            this.$refs.details.validate(valid => {
                if (valid) {
                    if(this.details.sectionId)
                    this.details.sectionName  =this.projectList.filter(item=>item.sectionId ==this.details.sectionId)[0].sectionName
                    let api =this.details.id? questionPut : questionPost
                    this.details.status=status
                    if(status==2)
                    this.details.submitrime=Date.now();
                    api(this.details).then(res=>{
                        this.$message.success(getToken()?this.$t('view.操作成功'):this.$t('view.您的问题已提交，运营人员将会与您联系'))
                        this.close()
                    })
                }
            })
        },
        close(){
            this.$router.push(getToken()?'MyQuestion':'/')
        },
        //招标项目列表
        questionGetAuthSection(){
            questionGetAuthSection().then(res=>{
                res.data.map(item=>{
                    item.sectionName  =this.locale=='en'?item.sectionNameEn:this.locale=='lo'?item.sectionNameLo: item.sectionName
                })
                this.projectList=res.data
            })
        }, 
    }
};
</script>
<style >
.MyQuestionDet .el-form-item__label{
    color: #909399;
}
</style>
<style lang="scss" scoped>
    .title{
        font-size: 16px;
        font-weight: 600;
        color: #333333;
    }
</style>